module.exports = __webpack_public_path__ + "public/media/ic_arrow_down_black.ce4ea32b.svg";